import type { IAudienceMeta } from '@/Interfaces/Audiences/Audience.interface';
import AudienceTargetingService from '@/Services/AudienceTargeting.service';
import type { GridRenderCellParams, GridValidRowModel } from '@mui/x-data-grid-pro';
import HiddenDataChip from '../HiddenDataChip';
import AudienceAndGroups from './AudienceGroups';
import AudienceOrGroup from './AudienceOrGroup';

const AudienceGroups = ({ value }: Pick<GridRenderCellParams<GridValidRowModel, IAudienceMeta>, 'value'>) => {
  if (!AudienceTargetingService.checkAudiencesInTargeting(value)) {
    return '—';
  }

  return (
    <div className='flex justify-center items-center gap-2'>
      {value?.include?.length ? (
        <HiddenDataChip hiddenData={<AudienceAndGroups andGroups={value.include} />} label='Included' />
      ) : null}
      {value?.exclude?.length ? (
        <HiddenDataChip hiddenData={<AudienceOrGroup orGroup={value.exclude} />} label='Excluded' />
      ) : null}
    </div>
  );
};

export default AudienceGroups;
